import React from 'react'
import './ShopPage.scss';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import carImage from '../imgs/shop-category-car.svg'
import bikeImage from '../imgs/shop-category-bike.svg'
import voucherImage from '../imgs/shop-category-voucher.svg'

import { Swipeable } from 'react-touch';

import { push } from 'connected-react-router'

import OrderCalendarPage from './OrderCalendarPage';
import VoucherPage from './VoucherPage';

import { loadShopData } from '../actions'
import { objectToArray } from '../helper'
import { Link } from 'react-router-dom'
import VoucherSlider from '../components/VoucherSlider'

import postNavButtonImage from '../scss/imgs/posts-nav-buttton.svg'


class VoucherCourses extends React.Component { 

    render() {
        const props = this.props

        return (
        <article className={"shop-page page"}>
            <section className="section gray-section on-screen">
                <div className="section-content">
                    <div className="container">
                        <p className="text-center">
                            <Link to="/shop/gutscheine/" className="white-btn">zurück</Link>
                        </p>
                        <h1 className="text-center shop-title">Training auswählen</h1>
                        <VoucherSlider vehicleTypeId={props.match.params.vehicleTypeId} />
                    </div>
                </div>
            </section>
        </article>
        )
    }
}

const mapStateToProps = state => {
  return {
    
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default withRouter(connect(
    mapStateToProps, 
    mapDispatchToProps
)(VoucherCourses))


// WEBPACK FOOTER //
// ./src/pages/VoucherCourses.jsx